<template>
  <v-radio-group v-model="paymentOption" :mandatory="false">
    <div
      style="min-height: 77px;"
      class="radio-option-custom pt-0"
      @click="paymentOption = option.id"
      :class="paymentOption == option.id ? 'option-active' : 'option-deactive'"
    >
      <v-layout class="radio-option__info">
        <v-flex>
          <v-layout row>
        <svg style="width:24px;height:24px; margin-top: 16px;" viewBox="0 0 24 24">
          <path
            fill="#656565"
            d="M2,6H4V18H2V6M5,6H6V18H5V6M7,6H10V18H7V6M11,6H12V18H11V6M14,6H16V18H14V6M17,6H20V18H17V6M21,6H22V18H21V6Z"
          />
        </svg>
        <div class="radio-option__info-text ml-4">
          <label :for="option.id">{{ option.label }}</label>
          <h4 class="checkout-h4 grey--text">{{ option.info }}</h4>
        </div>
          </v-layout>
        </v-flex>
        <v-flex shrink>
          <v-radio style="margin-right: 6px;" color="primary" :id="option.id" :value="option.id"></v-radio>
        </v-flex>
      </v-layout>

      <div class="pr-3" v-if="paymentOption === 'BB'">
        <v-text-field
            class="custom-text"
            outline
            required
            :readonly="natalLuzAgency"
            :label="selectedDocument === 'cpf' ? 'Nome Completo' : 'Razão Social'"
            v-model="payer_name"
        ></v-text-field>
        <v-select
          v-if="paymentData && paymentData.billet_max_installments && paymentData.billet_max_installments > 1"
          outline
          class="pr-1 custom-text"
          required
          :items="itemsInstallmentsBillet"
          v-model="installmentsBillet"
          label="Parcelas"
        ></v-select>
        <v-layout>
            <v-flex xs6>
                <v-select
                    outline
                    class="pr-1 custom-text"
                    required
                    :readonly="natalLuzAgency"
                    :items="documents"
                    v-model="selectedDocument"
                    label="Documento"
                ></v-select>
            </v-flex>
            <v-flex xs6>
                <v-text-field
                    class="pl-1 custom-text"
                    outline
                    required
                    :readonly="natalLuzAgency"
                    label="Número"
                    v-model="payer_doc"
                    :mask="selectedDocument === 'cpf' ? '###.###.###-##' : '##.###.###/####-##'"
                    :rules="selectedDocument === 'cpf' ? cpfRule : cnpjRule"
                ></v-text-field>
            </v-flex>
        </v-layout>
    </div>
    </div>
  </v-radio-group>
</template>

<script>
import Vue from 'vue';
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      natalLuzAgency: false,
      option: {
        id: 'BB',
        label: 'Boleto',
        info: 'Pague em até um dia útil',
      },
      documents: [
        {text: 'CPF', value: 'cpf'},
        {text: 'CNPJ', value: 'cnpj'},
    ],
    required: [v => !!v || 'Campo obrigatório'],
     cnpjRule: [
      cnpj => {
         if (cnpj && cnpj.length) {
          cnpj = cnpj.replace(/[^\d]+/g,'');

          if(cnpj === '') return 'CNPJ inválido';

          if (cnpj.length !== 14)
              return 'CNPJ inválido';

          // Elimina CNPJs invalidos conhecidos
          if (cnpj === "00000000000000" ||
              cnpj === "11111111111111" ||
              cnpj === "22222222222222" ||
              cnpj === "33333333333333" ||
              cnpj === "44444444444444" ||
              cnpj === "55555555555555" ||
              cnpj === "66666666666666" ||
              cnpj === "77777777777777" ||
              cnpj === "88888888888888" ||
              cnpj === "99999999999999")
              return 'CNPJ inválido';

          // Valida DVs
          let tamanho = cnpj.length - 2
          let numeros = cnpj.substring(0,tamanho);
          let digitos = cnpj.substring(tamanho);
          let soma = 0;
          let pos = tamanho - 7;
          for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                  pos = 9;
          }
          let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
          if (parseInt(resultado) !== parseInt(digitos.charAt(0)))
              return 'CNPJ inválido';

          tamanho = tamanho + 1;
          numeros = cnpj.substring(0,tamanho);
          soma = 0;
          pos = tamanho - 7;
          for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                  pos = 9
          }
          resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
          if (parseInt(resultado) !== parseInt(digitos.charAt(1)))
                return 'CNPJ inválido'

          return true
        } else {
          return 'CNPJ inválido';
        }
      }
    ],
    cpfRule: [
        cpf => {
          let numeros;
          let digitos;
          let soma;
          let i;
          let resultado;
          let digitosIguais;
          digitosIguais = 1;
          if (cpf && cpf.length < 11) {
            return 'CPF inválido';
          }
          if (cpf  && cpf.length) {
            for (i = 0; i < cpf.length - 1; i++) {
              if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
                digitosIguais = 0;
                break;
              }
            }
          }
          if (!digitosIguais) {
            numeros = cpf.substring(0, 9);
            digitos = cpf.substring(9);
            soma = 0;
            for (i = 10; i > 1; i--) {
              soma += numeros.charAt(10 - i) * i;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
            if (resultado !== parseInt(digitos.charAt(0))) {
              return 'CPF inválido';
            }
            numeros = cpf.substring(0, 10);
            soma = 0;
            for (i = 11; i > 1; i--) {
              soma += numeros.charAt(11 - i) * i;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
            if (resultado !== parseInt(digitos.charAt(1))) {
              return 'CPF inválido';
            }
            return true;
          }
          return 'CPF inválido';
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      userBilletProps: 'userBilletProps',
      userProps: 'userProps',
      cupomData: 'cupomData',
      paymentData: 'paymentData',
      orderData: 'paymentData',
      productsOrder: 'productsOrder',
      cartProducts: 'cartProducts',
      eventID: 'eventID',
      partialValue: 'partialValue',
      orderPdvData: 'orderPdvData'
    }),

    installmentsBillet: {
      get() {
        return this.userBilletProps.installmentsBillet;
      },
      set(val) {
        this.setUserBilletProps({ selectedDocument: this.selectedDocument, payer_name: this.payer_name, payer_doc: this.payer_doc, installmentsBillet: val });
      },
    },
    paymentOption: {
      get() {
        return this.$store.getters.paymentOption;
      },
      set(value) {
        this.$store.dispatch('setPaymentOption', value);
      },
    },

    payer_name: {
      get() {
        return this.userBilletProps.payer_name;
      },
      set(val) {
        this.setUserBilletProps({ selectedDocument: this.selectedDocument, payer_name: val, payer_doc: this.payer_doc, installmentsBillet: this.installmentsBillet });
      },
    },
    payer_doc: {
      get() {
        return this.userBilletProps.payer_doc;
      },
      set(val) {
        this.setUserBilletProps({ selectedDocument: this.selectedDocument, payer_name: this.payer_name, payer_doc: val, installmentsBillet: this.installmentsBillet });
      },
    },
    selectedDocument: {
      get() {
        return this.userBilletProps.selectedDocument;
      },
      set(val) {
        this.setUserBilletProps({ selectedDocument: val, payer_name: this.payer_name, payer_doc: this.payer_doc, installmentsBillet: this.installmentsBillet });
      },
    },
    itemsInstallmentsBillet () {
      if (this.paymentData && this.paymentData.billet_max_installments && this.paymentData.billet_max_installments > 1) {
        let array = []
        let totalValue = 0
        if (this.itsPartialPayment) totalValue = totalValue = this.partialValue * 100
        else if (this.$route.name === 'commissioner') this.totalModeOrder
        else totalValue = this.productsTotal
        for (let i = 0; i < this.paymentData.billet_max_installments; i++) {
          let string = (totalValue / (i + 1))
          array.push({text: `${i + 1}x de ${Vue.options.filters.currency(string)}`, value: i + 1})
        }
        return array
      } else return []
    },
    itsPartialPayment () {
      if (this.$route.name !== 'commissioner' && this.paymentData && this.paymentData.split_payment && this.productsTotal && this.partialValue < this.productsTotal) return Number(this.productsTotal)
      if (this.$route.name === 'commissioner' && this.orderPdvData && this.orderPdvData.valor_pendente && (this.partialValue < Number(this.orderPdvData.valor_pendente))) return Number(this.orderPdvData.valor_pendente)
      return 0
    },
    productsTotal() {
      if (this.isCardPaymentOption) {
        return this.$store.getters.totalAmount;
      }

      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total * 100;
    },
    totalModeOrder () {
      if (this.productsOrder) {
        let total = 0
        this.productsOrder.forEach(p => {
          total += p.quantidade * (Number(p.valor) + Number(p.valor_conveniencia))
        })
        return total * 100
      } else return 0
    }
  },
  mounted () {
    if (this.paymentData && this.paymentData.billet_max_installments && this.paymentData.billet_max_installments > 1) this.option.info = `Pague a primeira parcela do seu pedido até o dia ${moment(this.paymentData.billet_due_date).format('DD/MM/YYYY')}`
    if (this.cupomData && this.cupomData.campaign_name === 'Agências') {
      this.natalLuzAgency = true
    }
  },
  watch: {
    paymentOption () {
      if (this.paymentOption === 'BB' && this.userProps.name && this.userProps.document) {
        this.setUserBilletProps({ payer_name: this.userProps.name, payer_doc: this.userProps.document, selectedDocument: this.userProps.selectedDocument, installmentsBillet: this.installmentsBillet });
      } else {
        this.selectedDocument = 'cpf'
        setTimeout(() => {this.installmentsBillet = 1}, 1)
      }
    }
  },
  methods: {
      ...mapActions({
      setUserBilletProps: 'setUserBilletProps'
    }),
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/payment/paymentBillet.styl'
</style>

<style>
.custom-text .v-label {
  top: 18px !important;
}
</style>
